import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Oauth {

  http: HttpClient;
  constructor(private httpclient: HttpClient) {
    this.http = httpclient;
  }
  static getTokenDSI() {
    //return this.getParameterByName('code');
    return this.getParameterByName('access_token');
  }
  static tokenURLExists() {
    let result: boolean;
    debugger;
    //let token = this.getParameterByName('access_token');
    let token = this.getParameterByName('code');

    // console.log('el token 1 obtenido es ',token);

    // alert('el token 1 obtenido es ' + token)

    if (result = token !== '') {

      localStorage['acTkn'] = token;
    }

    if (token !== '' || token != null) {
      return token;
    }

    return result;
  }

  static getCode(): string {

    let code = this.getParameterByName('code');
    return code;
  }

  static login(obj) {
    let acTkn = this.getParameterByName('code');
    //let a1cTkn = this.getParameterByName('access_token');
    if (acTkn !== '') {
      localStorage['acTkn'] = acTkn;
    }
    // if (a1cTkn !== '') {
    //   localStorage['acTkn'] = acTkn;
    // }
    else this.redirect(obj);
  }
  static redirect(obj) {
    let uri = obj.endPoint;
    let urlGet = uri + '?response_type=' + obj.params.response_type
    urlGet += '&client_id=' + obj.params.client_id
    urlGet += '&redirect_uri=' + obj.params.redirect_uri
    urlGet += '&scope=' + obj.params.scope
    urlGet += '&state=' + obj.params.state;

    window.location.href = urlGet; //uri + '?' + $.param(obj.params);
  }

  static getParameterByName(name) {
    // name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    // var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    //   results = regex.exec(location.hash);
    //   alert('direccion: ' + regex)
    // return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    debugger;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get(name)
    return code;
  }


  static logout(urlSite, endPoint, idToken, loginState) {
    //window.location.href = endPoint + urlSite;
    let urlRedirection = endPoint + '?id_token_hint=' + idToken + '&post_logout_redirect_uri=&state=' + loginState;
    // console.log('url salida: ', urlRedirection);
    window.location.href = urlRedirection;
  }
}
